<template>
  <div class="modalOut">
    <slotModal
      :id-modal="'modalOut'"
      :modal-title="idsnap_transaksi"
      :footer="false"
      v-model="modal"
      @close="close"
      class="titleModal"
    >
      <template v-slot:modal-content>
        <div
          class="modal-top d-flex flex-column justify-content-center align-items-start align-self-stretch p-3"
          style="background-color: #f2f5f7"
        >
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex flex-column align-items-start">
              <p
                class="f-Overpass f-w-400 m-0 f-12 text-center align-items-start"
              >
                No Nota
              </p>
              <p
                class="f-Overpass f-w-600 m-0 f-14 text-center align-items-start"
              >
                {{ idsnap_transaksi }}
              </p>
            </div>

            <div class="d-flex flex-column align-items-end">
              <p
                class="f-Overpass f-w-400 m-0 f-12 text-center align-items-start"
              >
                Tanggal
              </p>
              <p
                class="f-Overpass f-w-600 m-0 f-14 text-center align-items-start"
              >
                {{ $moment(created_at).format("L") }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="d-flex p-16 flex-column align-items-start align-self-stretch m-3"
          style="gap: 8px"
        >
          <p class="f-Overpass f-w-600 m-0 f-14 text-center align-items-start">
            {{ nama_mesin }}
          </p>
          <div class="d-grid align-items-start">
            <p class="f-Overpass f-w-400 f-12 m-0 f-c-grey">layanan</p>
            <p class="f-Overpass f-w-400 f-14 m-0 f-c-black">
              {{ nama_layanan }}
            </p>
          </div>
          <div class="d-flex align-items-center" style="gap: 4px">
            <img src="../../../../assets/icons/time.svg" alt="time" />
            <p class="f-Overpass f-12 f-w-400 mt-1 my-0 f-c-grey">
              {{ displayDuration(durasi) }}
            </p>
          </div>
          <div class="d-flex align-items-center" style="gap: 4px">
            <img src="../../../../assets/icons/location.svg" alt="time" />
            <p class="f-Overpass f-12 f-w-400 mt-1 my-0 f-c-grey">
              {{ nama_outlet }}
            </p>
          </div>
        </div>

        <div
          class="d-flex p-a-16 flex-column align-items-start"
          style="border-top: solid 2px #ededed"
        >
          <div class="d-flex align-items-start justify-content-between w-100">
            <p class="f-Overpass f-c-black f-14 f-w-400 m-0">Harga Layanan</p>
            <p class="f-Overpass f-c-red f-14 f-w-400 m-0">
              {{ displaySaldo(price) }}
            </p>
          </div>
        </div>
      </template>
    </slotModal>
  </div>
</template>

<script>
import slotModal from "@/components/slots/slotModal.vue";

export default {
  name: "modalOut",
  props: {
    idsnap_transaksi: String,
    created_at: String,
    price: Number,
    nama_mesin: String,
    nama_layanan: String,
    durasi: Number,
    nama_outlet: String,
  },
  components: {
    slotModal,
  },
  data() {
    return {
      modal: false,
    };
  },

  methods: {
    displaySaldo(money) {
      const formattedMoney = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(money);

      return formattedMoney.replace(/\.00$/, "");
    },

    displayDuration(duration) {
      const minutes = Math.floor(duration / 60);
      return `${minutes} Menit`;
    },
    open() {
      this.modal = true;
    },
    close() {
      this.modal = false;
    },
  },
};
</script>
